import React, { useEffect, useMemo, useState } from 'react';
import { Outlet, NavLink, useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import GiftShopReviewsAndRating from '../components/CourseReviewsAndRating/GiftShopReviewsAndRating';
import ResponsiveNav from '../components/navigation/navigation';
import ItemDetails from '../components/ItemDetails/ItemDetails';
// import { gifts } from '../data/StaticDatas';
import { useGet, usePost } from '../hooks/useApi';
import { gifts } from '../data/StaticDatas';

const GiftItemDetails = () => {
  const { id } = useParams();

  const customerId = sessionStorage.getItem("userId"); 
  
  const { data: itemDetails, error: itemErr, isLoading: itemLoader} = useGet(`/api/GiftItems/get-item-details/${id}`);
  const item = itemDetails?.data
  
  // console.log(customerId)
  // const {longDesciption,name,size,} = item
  // console.log(item);
  
  const favUrl = useGet(`/api/GiftItems/add-giftItem-to-favorite?giftId=${id}&customerId=${customerId}`)
  console.log("Favorite URL Response:", favUrl);
  // const favUrl = `https://daradservice.azurewebsites.net/api/GiftItems/add-giftItem-to-favorite?giftId=${id}&customerId=${customerId}`;

  const { data, error, isLoading } = useGet(`/api/GiftItems/get-card-details/${id}`);
  const gift = data?.data
  console.log(gift)
  const breadcrumbItems = [
    { label: 'Home', link: '/' },
    { label: 'Gift Shop', link: '/product/giftshop' },
    { label: `Product Details`, link: `/product/gift-details/${id}` },
  ];
  const [loading, setLoading] = useState(false);
  useEffect(() => {


    if (itemLoader) {
      setLoading(true);
      return;
    }

  }, [itemLoader]);


  //  // Find the gift by its ID
  //  const gift = gifts.find(gift => gift.id === id);
  //  console.log(gift.specification.map((item)=>({label:item.Label, value:item.Value})))

   // Find the gift by its ID
  //  const gift = gifts.find(gift => gift.id === id);
  //  console.log(gift.specification.map((item)=>({label:item.Label, value:item.Value})))

   // If the gift doesn't exist, show an error
   if (itemLoader) {
    return <CircularProgress sx={{ display: "block", margin: "20px auto" }} />;
  }

  if (itemErr) {
    return (
      <Box sx={{ textAlign: 'center', mt: 4 }}>
        <Typography variant="h6" color="error" sx={{ fontFamily: theme => theme.typography.smallText }}>
          Something went wrong while loading this item.
        </Typography>
        <Typography sx={{ mt: 1, fontFamily: theme => theme.typography.smallText }}>
          Our technical support team will fix it ASAP.
        </Typography>
      </Box>
    );
  }
  

  return (
    <Box>
      <ResponsiveNav breadcrumbItems={breadcrumbItems} searchValue="" onSearchChange={() => {}} searchPlaceholder="Search..." />
      <ItemDetails buttontext={'Add to Favorites'} url={favUrl} detail='Specification' items={item} item_details={[{label:'Size', value:item?.size}]}
    />

      {/* Description and Rating outlet*/}
      <Box sx={{mt:8}}>
        <GiftShopReviewsAndRating/>
      </Box>
    </Box>

  )
}

export default GiftItemDetails